import { render, staticRenderFns } from "./ProjectViewSidebarCustomOrderSwitch.vue?vue&type=template&id=0bbd792c&scoped=true"
import script from "./ProjectViewSidebarCustomOrderSwitch.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarCustomOrderSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarCustomOrderSwitch.vue?vue&type=style&index=0&id=0bbd792c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd792c",
  null
  
)

export default component.exports